import { Component, inject } from '@angular/core';
import {
  IAM_PROFILE_KEY,
  
} from '../../../shared/service/storage.service';
import { User } from '../../../shared/models/user';
import { BaseComponent } from '../../../base/components/base.component';
import { IamUserProfileResponse } from '../../../shared/service/auth.service';
import {
  NoxDialogParam,
  NoxDialogType,
} from '../../../shared/models/nox-dialog-param';
import { NoxDialogComponent } from '../../../shared/components/nox-dialog/nox-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ClickableDirective } from '../../../shared/directives/clickable.directive';

@Component({
    selector: 'app-user-profile',
    imports: [ClickableDirective],
    templateUrl: './user-profile.component.html',
    styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent
  extends BaseComponent
 
{
  dialog = inject(MatDialog);
  userData?: (Partial<User> & IamUserProfileResponse) | null;

  get displayName(): string {
    return (
      this.userData?.profile?.firstName?.trim() ||
      this.userData?.profile?.fullName?.trim() ||
      'NA'
    );
  }

  get displayPhone(): string {
    return this.userData?.identity?.phone || this.userData?.phone || 'NA';
  }

  get displayEmail(): string {
    return this.userData?.identity?.email || this.userData?.email || 'NA';
  }

  get profileImage(): string {
    return this.userData?.user_image || '../../../../assets/svg/default-user.svg';
  }

  previewImage(url?: string) {
    let noxDialogData: NoxDialogParam = {
      type: NoxDialogType.image,
      imageUrl: url,
    };
    this.dialog.open(NoxDialogComponent, {
      data: noxDialogData,
    });
  }

  constructor() {
    super();
    this.userData = this.storageService.getObject(IAM_PROFILE_KEY);
  }
  goBack(): void {
    this.baseUserService.back();
  }
}
